/**
 * 権限の定数定義
 */
export namespace UserRole {
  /** 生徒権限 */
  export const STUDENT = 'student'

  /** 先生権限 */
  export const TEACHER = 'teacher'

  /** 教室長権限 */
  export const BRANCH = 'branch'

  /** 塾管理者権限 */
  export const ACADEMY = 'academy'

  /** 生徒権限 */
  export const ADMIN = 'admin'
}
